module.exports = {
  "country": "LT",
  "artist": "Silvester Belt",
  "song": "Luktelk",
  "year": "2024",
  "place": "14",
  "spotify": "6imf6Ru34HlM1JVTGgCIpy"
};